<!--go-chat-duplication-->
<button type="button" mat-icon-button [matMenuTriggerFor]="primaryNotificationMenu">
  <mat-icon
    aria-hidden="false"
    [matBadgeHidden]="unreadNotificationsCount() === 0"
    [matBadge]="unreadNotificationsCount().toString()">
    notifications
  </mat-icon>
</button>
<mat-menu #primaryNotificationMenu="matMenu">
  <div id="menu-container">
    @if (notifications().length === 0) {
      <a disabled mat-menu-item>You have no notifications</a>
    }
    @for (notification of notifications(); track notification) {
      @switch (notification.data.type) {
        @case ('chatRequest') {
          <app-go-primary-notification appGoChatRequestNotification [notificationData]="notification" />
        }
        @case ('chatUpgraded') {
          <app-go-primary-notification appGoChatUpgradeNotification [notificationData]="notification" />
        }
        @case ('assignedPatient') {
          <app-go-primary-notification appGoAssignedPatientNotification [notificationData]="notification" />
        }
      }
      <mat-divider />
    }
    @if (notifications().length > 0) {
      <button
        type="button"
        [disabled]="unreadNotificationsCount() === 0"
        mat-menu-item
        class="mark-all-read"
        (click)="markAllChatRequestNotificationsAsRead()">
        Mark All As Read
      </button>
    }
  </div>
</mat-menu>
